import { render } from "./StoriesSection.vue?vue&type=template&id=d7920b4c&scoped=true"
import script from "./StoriesSection.vue?vue&type=script&lang=js"
export * from "./StoriesSection.vue?vue&type=script&lang=js"

import "./StoriesSection.vue?vue&type=style&index=0&id=d7920b4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7920b4c"]])

export default __exports__